import Actions from './actions';

const setAffiliate = Actions.setAffiliate;

export { setAffiliate };
